export default __webpack_public_path__ + "static/media/masao.02ec1f65.jpg";